export default __webpack_public_path__ + "static/media/upload.1c3c4547.svg";